import script from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminShowsList.vue?vue&type=style&index=0&id=c48916c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c48916c6"]])

export default __exports__